/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Rights_Tools_Drawer_Remove_Pending_LabelInputs */



/**
* | output |
* | --- |
* | "Remove pending tool {tool}" |
*
* @param {Rights_Tools_Drawer_Remove_Pending_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_remove_pending_label = /** @type {((inputs: Rights_Tools_Drawer_Remove_Pending_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Remove_Pending_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ausstehendes Tool ${i?.tool} entfernen`)
	return /** @type {LocalizedString} */ (`Remove pending tool ${i?.tool}`)
});